import type { FC } from 'react';
import IcoMoon from 'react-icomoon';

import type { IIconProps } from '../../types';
import iconSet from '../../assets/images/icons.json';

export const Icon: FC<IIconProps> = ({ icon, ...props }: Record<string, any>) => (
    <IcoMoon icon={icon} iconSet={iconSet} {...props} />
);
